// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1OOry","signatureButtonsRight":"ModalSign_signatureButtonsRight__3c6NP"};